import {Typography} from '@mui/material';
import React from 'react';
import {CustomAlertContainer} from './styles';
import Icon from 'presentation/icons';
import {CustomAlertProps} from './types';

export function CustomAlert({message}: CustomAlertProps) {
	return (
		<CustomAlertContainer>
			<Icon name="warning-outlined" size={24} />
			<Typography variant="body2">{message}</Typography>
		</CustomAlertContainer>
	);
}
